import * as React from 'react';
import { useContext } from 'react';

import { Popup } from '@progress/kendo-react-popup';
import {
    ListView,
    ListViewHeader,
    ListViewFooter,
} from '@progress/kendo-react-listview';
import { Button } from '@progress/kendo-react-buttons';
import { useNotificationAPI, useNotificationData } from '../NotificationProvider';
import { AppUserContext } from '../PvsContextProvider';

export const Notifications = () => {
    const anchor = React.useRef(null);
    const [show, setShow] = React.useState(false);
    const notificationAPI = useNotificationAPI();
    const notificationData = useNotificationData();
    const appUserContext = useContext(AppUserContext);

    const NotificationHeader = () => {
        return (
            <ListViewHeader
                style={{
                    color: 'black',
                    fontSize: 19,
                    borderBottom: '1px solid #dee2e6',
                    minWidth: '250px'
                }}
                className="pl-3 pb-2 pt-2"
            >
                Notifications
            </ListViewHeader>
        );
    };
    const NotificationFooter = () => {
        return (
            <ListViewFooter
                style={{
                    color: 'black',
                    fontSize: 19,
                }}
                className="pl-3 pb-2 pt-2"
            >
            </ListViewFooter>
        );
    };

    const notificationColor = (item: any) => {
        switch (item.type) {
            case 'error':
                return '#dc3545';
            case 'success':
                return '#28a745';
            case 'warning':
                return '#ffc107';
            case 'info':
                return '#17a2b8';
            case 'none':
                return 'gray';
            default:
                return 'black';
        }
    }

    const NotificationItem = (props: any) => {
        let item = props.dataItem;
        return (
            <div
                className="row p-2 border-bottom align-middle"
                style={{
                    margin: 0,
                }}
            >
                <div className="col message-container">
                    <h1
                        style={{
                            fontSize: 14,
                            color: 'black',
                            marginBottom: 0,
                        }}
                    >
                        <span style={{ color: notificationColor(props.dataItem) }} className={"k-icon k-i-" + item.type}></span> &nbsp;
                        {item.text}
                        <span className="k-button-icon k-icon k-i-close" style={{ float: 'right' }} onClick={() => { notificationAPI.removeNotificationFromAll(item.time); }}></span>
                    </h1>

                    <h2
                        style={{
                            fontSize: 12,
                            color: 'black',
                            marginBottom: 0,
                        }}
                    >
                        <span style={{ float: 'left' }}>{item.page}</span>
                        <span style={{ float: 'right' }}>{(new Date(item.time)).toLocaleTimeString()}</span>
                    </h2>
                </div>
            </div>
        );
    };

    const onClick = () => {
        setShow(!show);
    };

    return (
        <div>
            {appUserContext.isStreckAdmin && notificationData.popupNotifications.filter(x => x.type === "error" || x.type === "warning").length > 0 &&
                <>
                    <span style={{ backgroundColor: "gray", position: "absolute", width: "100vw", height: "100vh", top: 0, left: 0, "zIndex": 998, opacity: "40%" }}>
                    </span>
                    <span style={{ position: "absolute", textAlign: "center", top: "50%", bottom: "50%", width: "100vw", "zIndex": 999, height: "25px", background: "#444", color: "white", left: "0" }} >
                        Please close all warnings and errors to continue
                    </span>
                </>
            }
            <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={onClick}
                ref={anchor}
            >
                <span title="Notifications" className="k-icon k-i-notification"></span>
            </button>
            <Popup anchor={anchor.current} show={show} popupClass={'popup-content'}>
                <ListView
                    data={notificationData.allNotifications}
                    item={NotificationItem}
                    style={{
                        width: '500px',
                    }}
                    header={NotificationHeader}
                    footer={NotificationFooter}
                />
                {notificationData.allNotifications?.length > 0 &&
                    <Button onClick={() => notificationAPI.clearNotifications()}>
                        Clear
                    </Button>
                }
            </Popup>
        </div>
    );
};